export default __webpack_public_path__ + "static/City_Leeds-ee843327b1ba414ee3cbe5a519018d5d.jpeg";